<div class="card border-0 mt-4 box-shadows">
    <div class="card-header p-0 bg-white border-0" role="tab" id="headingOne1">
        <a #toggleAccordian data-toggle="collapse" data-parent="#accordionEx" href="#collapseOne1"
        aria-expanded="true" aria-controls="collapseOne1">
        <h5 class="mb-0">
            <div class="row p-4">
                <div class="col-10 sm-14 color-blue font-weight-bold">
                    Add a new receiving method
                </div>
                <div class="col-2">
                    <i class="fas fa-angle-down rotate-icon float-right"></i>
                </div>
            </div>
        </h5>
    </a>
</div>
<div #collapseOne1 id="collapseOne1" class="collapse p-0">
    <div class="card-body px-3">
        <h6 class="secondary-text sm-12 font-weight-bold">How would you like to receive funds?</h6>
        <form #requestMethodForm="ngForm" (ngSubmit)="saveDetails(requestMethodForm)">
            <div class="form-group">
                <select #selectedCountry="ngModel" name="request_country" ngModel (change)="onCountryChange($event.target.value)" class="form-control border-0">
                    <option value="" selected disabled>Country</option>
                    <option [value]="country.id" *ngFor="let country of countries">{{country.name}}</option>
                </select>
            </div>
            <div *ngIf="selectedCountry.value && selectedCountry.value!=101" class="form-group">
                <select  #bankCode="ngModel" ngModel name="bank_name_id"  class="form-control border-0">
                    <option value="" selected disabled>Bank Name</option>
                    <option [value]="bank.code" *ngFor="let bank of banks">{{bank.name}}</option>
                </select>
            </div>
            <div *ngIf="selectedCountry.value==101" class="form-group d-flex">
                <input (keyup)="bank_name=''" #ifscCode="ngModel" type="text" name="ifsc_code" ngModel class="input_field_blue p-3 sm-12 w-100" placeholder="IFSC Code of Bank" required>
                <button type="button" (click)="getBankName(ifscCode.value)" class="btn primary-btn h-auto">Verify</button>
            </div>
            <div *ngIf="selectedCountry.value==161" class="form-group d-flex">
                <input (keyup)="ac_holder_name=''" #accountNumber="ngModel" type="text" name="request_account_number" ngModel class="input_field_blue p-3 sm-12 w-100" placeholder="Account Number" required>
                <button type="button" (click)="getBankNameNig(requestMethodForm)" class="btn primary-btn h-auto">Verify</button>
            </div>
            <div *ngIf="selectedCountry.value && selectedCountry.value==101" class="form-group">
                <input type="text" [(ngModel)]="bank_name" name="bank_name" class="input_field_blue p-3 sm-12 w-100 "  placeholder="Bank Name" readonly required>
            </div>
            <div class="form-group">
                <input type="text" name="request_name" readonly [(ngModel)]="ac_holder_name" class="input_field_blue p-3 sm-12 w-100 " placeholder="Enter Your Name" required>
            </div>
            <div class="form-group">
                <input type="text" name="request_email" readonly [(ngModel)]="auth.user.email" class="input_field_blue p-3 sm-12 w-100 " placeholder="Enter Your Email" required>
            </div>
            <div *ngIf="selectedCountry.value && selectedCountry.value!=161" class="form-group">
                <input type="text" name="request_account_number" ngModel class="input_field_blue p-3 sm-12 w-100 " placeholder="Your Account Number" required>
            </div>
            <div *ngIf="selectedCountry.value && selectedCountry.value!=161" class="form-group">
                <input type="text" name="request_confirm_account" ngModel class="input_field_blue p-3 sm-12 w-100 " placeholder="Confirm Account Number" required>
            </div>
            <button [disabled]="!requestMethodForm.valid" type="submit" class="btn primary-btn w-100 h-auto sm-12">Add this receiving method</button>
        </form>
    </div>
</div>
</div>
